export const setAppMList = (state, reqResponse) => {
    state.appMList = reqResponse.data.object;
    state.loadingAppM = false;
};

export const deleteAppM = (state, app) => {
    state.appMList.splice(state.appMList.indexOf(app), 1);
};
